/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 22:20:26
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
export declare namespace ExceptionTaskDOI {
    export interface RowDataI {
        affirm_datatime: string;
        affirm_people: string;
        device_id: number;
        device_name: string;
        dispose_datatime: string;
        dispose_people: string;
        id: number;
        inform_number: string;
        initiator: string;
        ops_leader_status: number;
        dispose_condition: number;
        sponsor_datetime: string;
        task_number: string;
    }

    export interface QueryRowDataParamsI extends PageDo {
        keyword?: string;
        end_time?: Integer;
        start_time?: Integer;
        status?: Integer;
    }

    export interface QueryDetailResultI {
        device_id: number
        device_name: string
        dispose_condition: number
        dispose_explain: string
        id: number
        inform_number: string
        initiator: string
        operational_content: string
        operational_equipment: string[];
        sponsor_datetime: string
        task_number: string
    }

    export interface OperateParamsI {}
}
export default class ExceptionTaskApi {
    /**
     * 查询列表
     * @param {ExceptionTaskDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(
        params: ExceptionTaskDOI.QueryRowDataParamsI,
        isDistribute: boolean,
    ): Promise<ResultPageDo<ExceptionTaskDOI.RowDataI[]>> {
        return Api.post(isDistribute ? '/ops/abnormity_infrom_distribute/list/get' : '/ops/abnormity_infrom_dispose/list/get', {
            status: defaultNullValue,
            keyword: '',
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date()),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date('1990')),
            ...params,
        });
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number; device_id: number }): Promise<Result<ExceptionTaskDOI.QueryDetailResultI>> {
        return Api.post('/ops/abnormity_distribute/particulars/get', params);
    }
    static async distribute(data: { user_id: Integer; device_id: Integer; id: Integer }): Promise<Result<any>> {
        return Api.post('/ops/abnormity_task/distribute', data);
    }

    static async dispose(data: { dispose_explain: string; device_id: Integer; id: Integer }): Promise<Result<any>> {
        return Api.post('/ops/abnormity_task/dispose', data);
    }
}
